function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7341 14.4856L11.8102 10.5569C13.7831 7.98903 13.5858 4.27984 11.2183 1.93141C9.92495 0.636488 8.25891 0 6.57096 0C4.88301 0 3.21698 0.636488 1.92361 1.93141C-0.641203 4.49931 -0.641203 8.66941 1.92361 11.2373C3.21698 12.5322 4.88301 13.1687 6.57096 13.1687C7.97393 13.1687 9.37691 12.7298 10.5387 11.8299L14.4846 15.7366C14.66 15.9122 14.8792 16 15.1203 16C15.3395 16 15.5807 15.9122 15.7561 15.7366C16.0849 15.4074 16.0849 14.8368 15.7341 14.4856ZM6.59288 11.3909C5.29952 11.3909 4.11576 10.8861 3.19505 9.98628C1.33173 8.12071 1.33173 5.06996 3.19505 3.18244C4.09383 2.28258 5.29952 1.77778 6.59288 1.77778C7.88625 1.77778 9.07001 2.28258 9.99071 3.18244C10.9114 4.0823 11.3937 5.28944 11.3937 6.58436C11.3937 7.87929 10.8895 9.06447 9.99071 9.98628C9.09193 10.9081 7.86433 11.3909 6.59288 11.3909Z",
  fill: "currentColor"
});

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5c3b965c.svg";
export { ForwardRef as ReactComponent };